import * as yup from 'yup'

export const marketFormValidator = yup.object({
  title: yup.string().trim().required('Market name is required'),
  // Optional, matching `@IsOptional @IsString` on GigSafeAdminCreateMarketDTO.
  description: yup.string().trim(),
})
